export default "__VITE_ASSET__37d1430f__"